import styled from "styled-components";

export const RouteCircle = styled.div<{ colors: string[] }>`
  width: 24px;
  height: 24px;
  border-radius: 18px;
  box-shadow: 0 0 2px #00000055 inset;
  position: relative;
  background: ${({ colors }) => {
    const list = colors.map((color, index) => {
      return `${color} ${(index * 100) / colors.length}%, ${color} ${
        ((index + 1) * 100) / colors.length
      }%`;
    });

    return `
      repeating-linear-gradient(
        -45deg,
        ${list.join(",")}
      )
    `;
  }};
  &:after {
    content: "";
    display: none;
    width: 12px;
    height: 12px;
    background-color: #28ee77;
    color: white;
    position: absolute;
    bottom: -2px;
    right: -2px;
    z-index: 1;
    border-radius: 5px;
    background-position: center center;
    background-repeat: no-repeat;
  }
  &.tick:after {
    display: block;
    background-image: url("data:image/svg+xml,%3Csvg width='8' height='7' viewBox='0 0 8 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 3.28571L2.8 5L7 1' stroke='white' stroke-width='2'/%3E%3C/svg%3E%0A");
    background-position: 2px 3px;
  }
  &.flash:after {
    display: block;
    background-color: #ffe70d;
    color: black;
    background-position: 3px 3px;
    background-image: url("data:image/svg+xml,%3Csvg width='7' height='7' viewBox='0 0 6 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.22727 0H1.13636L0 3.29912H1.59091L0.681818 6.81818L5.45455 2.85924H3.18182L5.22727 0Z' fill='%23010024'/%3E%3C/svg%3E%0A");
  }
`;
